import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Tooltip, useMediaQuery, useTheme } from '@mui/material'
import { ETranslationNs } from 'src/types'

interface IProps {
  status: boolean
  label: string
}

export const StatusBadge = ({ status, label }: IProps) => {
  const [t] = useTranslation(ETranslationNs.Scans)
  const [isOpen, setIsOpen] = useState(false)

  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  const toggleTooltip = () => setIsOpen(!isOpen)

  const handleTooltipTrigger = (
    e: React.TouchEvent<HTMLSpanElement> | React.MouseEvent<HTMLSpanElement, MouseEvent>,
  ) => {
    e.stopPropagation()
    if (isTablet) {
      toggleTooltip()
    }
  }

  return (
    <Tooltip
      title={label}
      onClick={(e) => {
        e.stopPropagation()
      }}
      open={isTablet ? isOpen : undefined} // Controlled for tablets, automatic for others
      onClose={() => setIsOpen(false)}
    >
      <Box
        onClick={handleTooltipTrigger}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          minWidth: '10px',

          height: '16px',
          width: '16px',
        }}
      >
        <span
          style={{
            display: 'inline-flex',
            backgroundColor: status ? 'green' : '#E57373',
            borderRadius: '50%',
            width: 12,
            height: 12,
          }}
        />
      </Box>
    </Tooltip>
  )
}
